export default __webpack_public_path__ + "666e892fea74766607901277e2ab0249.png";